function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { Box, Card, Flex } from '@applyboard/crystal-ui';
import { Loading } from '@applyboard/ui-components';
import { useEventTracker } from '@applyboard/ui-utils';
import React, { useEffect, useState } from 'react';
import { useRevenueGeneratedChart } from "../../../data/rpRevenueGeneratedChartData";
import { useRevenueGeneratedMeta } from "../../../data/rpRevenueGeneratedChartMeta";
import { LineChart } from "./charts";
import { ChartProvider } from "./charts/utils/global";
import { ChartFilterDropdown, ChartHeader, TotalRevenueGenerated } from "./components";
import { getChartLineStrokeColor, getCurrencyDropdownOptions, getFullMonth, getYearDropdownOptions, updateAppliedFilters } from "./utils";
var defaultChartSeries = {
  data: Array(12).fill(null),
  name: 'Commissions',
  lineStrokeProps: {
    curveType: 'straight',
    color: 'blue-12'
  },
  total: 0
};
var REPORT_TITLE = 'Revenue generated';
var REPORT_SUBTITLE = 'Total amount of revenue generated by month';
var REVENUE_GENERATED_CHART_CATEGORIES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var eventObject = {
  event: 'Applied Filter(s) On Report',
  group: 'Agent Dashboard',
  data: {
    report: "Money Earned - Over time"
  }
};
var CHART_HEIGHT = 360;
export var RevenueGeneratedChart = function RevenueGeneratedChart(props) {
  var userId = props.userId,
    isAdmin = props.isAdmin;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    years = _useState2[0],
    setYears = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    currencies = _useState4[0],
    setCurrencies = _useState4[1];
  var _useState5 = useState([defaultChartSeries]),
    _useState6 = _slicedToArray(_useState5, 2),
    chartSeries = _useState6[0],
    setChartSeries = _useState6[1];
  var _useState7 = useState({
      label: '',
      value: ''
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedYear = _useState8[0],
    setSelectedYear = _useState8[1];
  var _useState9 = useState({
      label: '',
      value: ''
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedCurrency = _useState10[0],
    setSelectedCurrency = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    totalEarned = _useState12[0],
    setTotalEarned = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedCategory = _useState14[0],
    setSelectedCategory = _useState14[1];
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var defaultFilters = [{
    label: 'Year',
    value: selectedYear.label
  }];
  var _useState15 = useState(defaultFilters),
    _useState16 = _slicedToArray(_useState15, 2),
    appliedFilters = _useState16[0],
    setAppliedFilters = _useState16[1];
  var chartTooltipDescription = function chartTooltipDescription(point) {
    var currencySign = function currencySign(label) {
      if (label === 'GBP') {
        return '£';
      } else if (label === 'EUR') {
        return '€';
      }
      return '$';
    };
    return ["Total amount generated in ".concat(point.series.name.toLowerCase(), " in ").concat(getFullMonth(String(point.x)), " ").concat(selectedYear.value), "".concat(selectedCurrency.label, " ").concat(point.y && point.y < 0 ? '-' : '').concat(currencySign(selectedCurrency.label)).concat(point.y || point.y === 0 ? Math.abs(point.y) : '')];
  };
  var handleYearSelect = function handleYearSelect(option) {
    setSelectedYear(option);
    setAppliedFilters(updateAppliedFilters(appliedFilters, 'Year', option.label));
  };
  var handleCurrencySelect = function handleCurrencySelect(option) {
    setSelectedCurrency(option);
    setAppliedFilters(updateAppliedFilters(appliedFilters, 'Currency', option.label));
  };
  var calculateTotalEarnings = function calculateTotalEarnings(series) {
    var visibleSeries = [];
    series.forEach(function (item) {
      return item.visible ? visibleSeries.push(item.name) : null;
    });
    var totalEarned = chartSeries.reduce(function (acc, curV) {
      return visibleSeries.includes(curV.name) ? acc + curV.total : acc;
    }, 0);
    visibleSeries.length === 1 ? setSelectedCategory(visibleSeries[0]) : setSelectedCategory('');
    setTotalEarned(totalEarned);
  };
  var _useRevenueGeneratedC = useRevenueGeneratedChart(userId, selectedYear.value, selectedCurrency.value, isAdmin),
    rpRevenueGeneratedData = _useRevenueGeneratedC.rpRevenueGeneratedData;
  var _useRevenueGeneratedM = useRevenueGeneratedMeta(userId, isAdmin),
    rpRevenueGeneratedMetaData = _useRevenueGeneratedM.rpRevenueGeneratedMetaData,
    isFetchingRpRevenueGeneratedMeta = _useRevenueGeneratedM.isFetchingRpRevenueGeneratedMeta;
  useEffect(function () {
    var _rpRevenueGeneratedMe, _rpRevenueGeneratedMe2;
    if (!isFetchingRpRevenueGeneratedMeta && rpRevenueGeneratedMetaData && (_rpRevenueGeneratedMe = rpRevenueGeneratedMetaData.years) !== null && _rpRevenueGeneratedMe !== void 0 && _rpRevenueGeneratedMe.length && (_rpRevenueGeneratedMe2 = rpRevenueGeneratedMetaData.currencies) !== null && _rpRevenueGeneratedMe2 !== void 0 && _rpRevenueGeneratedMe2.length) {
      setYears(getYearDropdownOptions(rpRevenueGeneratedMetaData.years));
      setCurrencies(getCurrencyDropdownOptions(rpRevenueGeneratedMetaData.currencies));
    }
  }, [rpRevenueGeneratedMetaData, isFetchingRpRevenueGeneratedMeta]);
  useEffect(function () {
    if (rpRevenueGeneratedData) {
      var measuresArray = rpRevenueGeneratedData.data.map(function (revenueGeneratedData) {
        return revenueGeneratedData.measure;
      });
      var rpRevenueGeneratedSeries = rpRevenueGeneratedData.data.map(function (revenueGeneratedData) {
        return _objectSpread(_objectSpread({}, defaultChartSeries), {}, {
          name: revenueGeneratedData.measure,
          data: revenueGeneratedData.values,
          lineStrokeProps: _objectSpread(_objectSpread({}, defaultChartSeries.lineStrokeProps), {}, {
            color: getChartLineStrokeColor(measuresArray, revenueGeneratedData.measure)
          }),
          total: revenueGeneratedData.total
        });
      });
      setChartSeries(rpRevenueGeneratedSeries);
    }
  }, [rpRevenueGeneratedData]);
  if (isFetchingRpRevenueGeneratedMeta) return /*#__PURE__*/React.createElement(Flex, {
    align: "center",
    justify: "center",
    height: "fill"
  }, /*#__PURE__*/React.createElement(Loading, null));
  return /*#__PURE__*/React.createElement(ChartProvider, null, /*#__PURE__*/React.createElement(Card, {
    emphasis: "outlined"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ChartHeader, {
    chartTitle: REPORT_TITLE,
    chartSubtitle: REPORT_SUBTITLE,
    chartAppliedFilters: appliedFilters
  }, /*#__PURE__*/React.createElement(ChartFilterDropdown, {
    options: years,
    selectedOption: selectedYear,
    testId: "year-filter",
    onOptionSelect: handleYearSelect,
    placeholder: "Select a year",
    track: function track() {
      return trackEvent(_objectSpread(_objectSpread({}, eventObject), {}, {
        data: _objectSpread(_objectSpread({}, eventObject.data), {}, {
          filters: ['Year'] //type of filter
        })
      }));
    }
  }), /*#__PURE__*/React.createElement(ChartFilterDropdown, {
    options: currencies,
    selectedOption: selectedCurrency,
    testId: "category-filter",
    onOptionSelect: handleCurrencySelect,
    placeholder: "Select a currency",
    track: function track() {
      return trackEvent(_objectSpread(_objectSpread({}, eventObject), {}, {
        data: _objectSpread(_objectSpread({}, eventObject.data), {}, {
          filters: ['Currency'] //type of filter
        })
      }));
    }
  })), /*#__PURE__*/React.createElement(Flex, {
    align: "center",
    gap: 6
  }, /*#__PURE__*/React.createElement(Flex.Item, {
    grow: 1
  }, /*#__PURE__*/React.createElement(LineChart, {
    chartCategories: REVENUE_GENERATED_CHART_CATEGORIES,
    chartHeight: CHART_HEIGHT,
    chartSeries: chartSeries,
    chartTitle: REPORT_TITLE,
    chartTooltipDescription: chartTooltipDescription,
    calculateTotalEarnings: calculateTotalEarnings
  })), /*#__PURE__*/React.createElement(Flex.Item, {
    basis: "160px",
    shrink: 0
  }, /*#__PURE__*/React.createElement(TotalRevenueGenerated, {
    totalEarned: totalEarned,
    selectedCurrency: selectedCurrency,
    selectedCategory: selectedCategory
  }))))));
};